<template>
    <div class="pt-4">
        <loading-gdb :propObject="StateIDSecureVisitantesLoading"
            text="Carregando Visitantes" />
        
        <v-data-table :items="StateIDSecureVisitantes"
            class="custom-header-style"
            :headers="headers"
            :items-per-page="1000"
            v-model:sort-by="sortBy"
            loading-text="carregando..."
            no-data-text='Nenhum registro'
            no-results-text='Nenhum registro encontrado'
            :loading="StateIDSecureVisitantesLoading"
            :search="search_visitante"
            >
            <template v-slot:top>
                <v-row class="ma-1" align="end">
                    <v-text-field
                        v-model="search_visitante"
                        placeholder="Pesquisar Visitante"
                        hide-details
                        label="Pesquisar">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="formNewVisitante" title="atualizar">
                        <v-icon>mdi-plus</v-icon> Cadastrar
                    </v-btn>
                    <v-btn @click.stop="GetIDSecureVisitantes" title="atualizar" color="info">
                        <v-icon>mdi-refresh</v-icon> Atualizar
                    </v-btn>
                </v-row>
            </template>
            <!-- eslint-disable -->
            <template #item.details="{ item }">
                <v-btn icon @click.stop="readVisitante(item)" title="Visualizar cadastro">
                    <v-icon>mdi-eye-outline</v-icon>
                </v-btn>
            </template>
            <template #item.dateLimit_date="{ item }">
                {{$verify.formatarData(item.dateLimit_date)}}
            </template>
        </v-data-table>
        <!-- Formulário de Criação e atualização de Visitantes -->
        <modal-gdb ref="modal_read_visitante" code="modal_read_visitante"
                    toolbar-title="Visitante" dialogWidth="100%">
            <template v-slot:activate-slot>
                <span></span>
            </template>
            <template v-slot:body>
                <v-card-text >
                    <v-row>
                        <!-- Captura -->
                        <v-col cols="12" sm="3" md="3" lg="2">
                            <CapturaFoto
                                @image-changed="onSelectedImage"
                                :showOutPreview="false"/>
                            <div v-if="selectedVisitante.foto" class="my-1">
                                <v-img
                                    :src="'data:image/jpeg;base64,'+selectedVisitante.foto"
                                    width="200" style="border-radius:10px" />
                                <div :class="selectedVisitante.photoIdFaceState !== 1 ? 'text-error':''">
                                    Status:
                                    <span
                                        v-if="selectedVisitante.photoIdFaceState !== null"
                                        v-text="resultTest[selectedVisitante.photoIdFaceState]"></span>
                                    <span v-else>
                                        Imagem não processada
                                    </span>
                                </div>
                                <div class="text-center" v-if="selectedVisitante && selectedVisitante.foto">
                                    <v-btn color="error" @click.stop="selectedVisitante.foto = null">remover imagem</v-btn>
                                </div>
                                <div>
                                    Em: <span v-text="selectedVisitante.photoTimestamp_date"></span>
                                </div>
                                <div class="mt-8" v-show="selectedVisitante && selectedVisitante.id">
                                    <small>
                                        Aguarde até 2 minutos ou clique abaixo para acompanhar a atualização do status da foto
                                    </small>
                                    <v-btn class="mx-2" color="info" @click.stop="readVisitante(selectedVisitante)">
                                        <v-icon small>mdi-refresh</v-icon> atualizar
                                    </v-btn>
                                </div>
                            </div>
                            <div v-else> Sem Foto </div>
                        </v-col>
                        <!-- Formulário -->
                        <v-col cols="12" sm="6" md="6" lg="7">
                            <v-form ref="form" v-model="valid"
                                lazy-validation @submit.prevent="submit(selectedVisitante)">
                                <v-row>
                                    <v-col cols="12" sm="12" md="8">
                                        <v-autocomplete variant="outlined"
                                            v-model="selectedVisitante.groups" multiple
                                            :items="StateVisitantesGrupos"
                                            item-value="id" item-title="name"
                                            label="Grupo" placeholder="Grupo de Visitante...">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="8">
                                        <v-text-field variant="outlined" v-model="selectedVisitante.name"
                                            label="Nome..." placeholder="Nome e Sobrenome">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field variant="outlined" v-model="selectedVisitante.cpf"
                                            label="CPF..." placeholder="Nº CPF" v-mask="'###########'">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="8">
                                        <v-text-field variant="outlined" v-model="selectedVisitante.email"
                                            label="E-mail..." placeholder="E-mail" type="email">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field variant="outlined" v-model="selectedVisitante.telefone"
                                            label="Telefone..." placeholder="Contato" v-mask="'(##) #####-####'">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea variant="outlined" v-model="selectedVisitante.comments"
                                            label="Motivo da visita..." placeholder="Motivo" hide-details>
                                        </v-textarea>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-divider class="my-4"></v-divider>
                                        <h3 class="text-grey mb-4" >Autorização de Acesso</h3>
                                        <div v-if="selectedVisitante.expirado" class="my-3">
                                            <v-alert type="error">
                                                <h4 class="my-2 text-white">Acesso expirado</h4>
                                            </v-alert>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" xs="7" sm="7" md="6">
                                        <v-text-field type="date"
                                            v-model="selectedVisitante.date_expire"
                                            label="Data Limite de acesso"
                                            hide-details>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" xs="5" sm="5" md="6">
                                        <v-text-field type="time" hide-details
                                            v-model="selectedVisitante.time_expire"
                                            label="Horário Limite">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-btn v-if="selectedVisitante.expirado"
                                            title="Esta funcionalidade atualiza para a data de hoje"
                                            color="success"
                                            @click.stop="addDays(0)">Atualizar para hoje</v-btn>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <!-- OCULTADO ATE DEFINICAO DE POLITICA DE TEMPO -->
                                        <v-btn v-if="selectedVisitante.expirado && false" class="mx-1"
                                            title="Esta funcionalidade atualiza para a data de hoje" color="success"
                                            @click.stop="addDays(1)">Liberar até amanhã</v-btn>
                                    </v-col>
                                </v-row>
                                <v-divider class="my-3"></v-divider>
                                <v-row>
                                    <v-spacer></v-spacer>
                                    <v-btn  @click.stop="closeModal"
                                        class="ml-1" color="error">Cancelar</v-btn>
                                    <v-btn type="submit"
                                        class="ml-1" color="success">
                                        <span v-if="selectedVisitante && selectedVisitante.id"> Atualizar </span>
                                        <span v-else> Salvar </span>
                                    </v-btn>
                                </v-row>
                            </v-form>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" lg="3" v-if="selectedVisitante && selectedVisitante.id">
                            <div>
                                <h3>Detalhes</h3>
                                <v-divider class="my-2"></v-divider>
                            </div>
                            <div>
                                ID: <span v-text="selectedVisitante.id"></span>
                            </div>
                            <div>
                                IDDevice: <span v-text="selectedVisitante.idDevice"></span>
                            </div>
                            <div>
                                Validade: <span v-text="selectedVisitante.Validade"></span>
                            </div>
                            <div>
                                Reconhec. Facial: <span v-text="selectedVisitante.canUseFacial ? 'Sim': 'Não'"></span>
                            </div>
                            <div>
                                Contingência: <span v-text="selectedVisitante.contingency ? 'Sim': 'Não'"></span>
                            </div>
                            <div>
                                Tipo: <span v-text="selectedVisitante.idType == 0 ? 'Pessoa' : 'Visitante'"></span>
                            </div>
                            <div v-show="false">
                                Inativo: <span v-text="selectedVisitante.inativo ? 'Sim' : 'Não'"></span>
                            </div>
                            <div>
                                Expirado: <span v-text="selectedVisitante.expirado ? 'Sim' : 'Não'" :class="selectedVisitante.expirado ? 'text-error' : 'text-success'"></span>
                            </div>
                            <div>
                                Foto Removida: <span v-text="selectedVisitante.photoDeleted? 'Sim' : 'Não'"></span>
                            </div>
                            <div>
                                Cadastro em: <span v-text="selectedVisitante.timeOfRegistration_date"></span>
                            </div>
                            <div v-if="hasLogVisitantePerm">
                                Visualizar log deste visitante:
                                <v-btn target="_blank" color="info" small
                                    :to="{
                                        name:'logvisitante',
                                        params:{
                                            idDevice: selectedVisitante.idDevice
                                        }
                                    }"> Logs
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </template>
        </modal-gdb>
    </div>
</template>
<script>
import CapturaFoto from '@/components/layouts/partials/CapturaFoto.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'IDSecureVisitantes',
    components:{
        CapturaFoto
    },
    data:()=>({
        search_visitante:null,
        sortBy: [{ key: 'id', order: 'desc' }],
        headers:[
            { title: ' ', value: 'details', sortable: false, width: 10},
            { title: '#ID', key: 'id', sortable: false, width: 10},
            { title: 'Nome', value: 'name', sortable: false },
            { title: 'CPF', value: 'cpf_format', align: 'center', sortable: false, width: 50},
            { title: 'Autorizado até', value: 'dateLimit_date', align: 'end', sortable: false, width: 190},
        ],
        selectedVisitante:{},
        resultTest:{
            0  : 'Status desconhecido',
            1  : 'Foto Enviada',
            2  : 'Rosto muito longe',
            3  : 'Rosto muito perto',
            4  : 'Face não centralizada',
            5  : 'Postura do rosto não centralizada',
            6  : 'Baixa Nitidez',
            7  : 'Rosto não detectado',
            8  : 'Face já existente',
            9  : 'Tamanho de imagem desconhecido',
            10 : 'Imagem Pequena',
            11 : 'Imagem muito grande',
            12 : 'Usuário não existe',
            13 : 'Muitas faces já estão cadastradas no dispositivo',
            14 : 'Rosto muito perto das bordas da imagem',
        },
        originalTempFoto:null,
        valid:false,
        model_code:'',
        new_visitante_model:{
            name: '',
            telefone: '',
            email: '',
            cpf: '',
            date_expire: '',
            time_expire: '',
            comments: '',
            foto: null,
        }
    }),
    mounted(){
        this.GetIDSecureVisitantes()
        this.GetIDSecureVisitantesGrupos()
    },
    methods:{
        ...mapActions(['CreateIDSecureVisitante',
                        'UpdateIDSecureVisitante',
                        'GetIDSecureVisitantes',
                        'GetIDSecureVisitante',
                        'GetIDSecureVisitantesGrupos',
                        'gotoRoute']),
        readVisitante(value){
            if (value && value.id){
                let response = this.GetIDSecureVisitante(value.id)
                response.then(res=>{
                    this.selectedVisitante = Object.assign({}, res.data)
                    this.$refs.modal_read_visitante.dialog = true
                }).catch(err => {
                    console.error(err)
                    this.closeModal()
                })
            }
        },
        initDateExpire(days){
            // adicionar default no campo data
            let data = new Date();
            let add_days = days;
            data.setDate(data.getDate() + add_days);
            let year = data.getFullYear()
            let month = ("0" + (data.getMonth() + 1)).slice(-2)
            let day = data.getDate()
            let formatted = `${year}-${month}-${day}`
            return formatted
        },
        formNewVisitante(){
            this.selectedVisitante = Object.assign({}, this.new_visitante_model)
            this.selectedVisitante.date_expire = this.initDateExpire(0)
            this.selectedVisitante.time_expire = '23:59'
            this.$refs.modal_read_visitante.dialog = true
        },
        addDays(days){
            // // adicionar default no campo data
            // let data = new Date();
            // let add_days = days;
            // data.setDate(data.getDate() + add_days);
            // let year = data.getFullYear()
            // let month = ("0" + (data.getMonth() + 1)).slice(-2)
            // let day = data.getDate()
            // let formatted = `${year}-${month}-${day}`
            this.selectedVisitante.date_expire = this.initDateExpire(days)
            this.selectedVisitante.time_expire = '23:59'
        },
        onSelectedImage(value){
            if (value){
                // salvar base64 da imagem original
                const originalTempFoto = this.selectedVisitante.foto
                this.originalTempFoto = originalTempFoto
                this.selectedVisitante.foto = value
            }else{
                // em caso de desistencia, não perder o base64 da imagem original
                const recoveryOriginal = this.originalTempFoto
                this.originalTempFoto = null
                this.selectedVisitante.foto = recoveryOriginal
            }
        },
        closeModal(){
            this.$refs.modal_read_visitante.dialog = false
            this.resetSelectedVisitante()
        },
        resetSelectedVisitante(){
            this.selectedVisitante = Object.assign({}, {})
        },
        async updateVisitante(cadastro){
            await this.UpdateIDSecureVisitante(cadastro)
            this.closeModal()
            this.GetIDSecureVisitantes()
        },
        async createVisitante(cadastro){
            await this.CreateIDSecureVisitante(cadastro)
            this.closeModal()
            this.GetIDSecureVisitantes()
        },
        async submit(cadastro){
            if(!(cadastro.groups||[]).length) {
                this.$store.commit("setAlerts", [ {
                    message: `Grupos do Visitante não foi informado!`,
                    tag: 'warn',
                    timeout: '5000',
                    title: 'Grupo'
                }])
                return
            }
            if(!(cadastro.name||[]).length) {
                this.$store.commit("setAlerts", [ {
                    message: `Nome do Visitante não foi informado!`,
                    tag: 'warn',
                    timeout: '5000',
                    title: 'Nome'
                }])
                return
            }
            if (cadastro && cadastro.id){
                // Atualizar
                await this.updateVisitante(cadastro)
            }else{
                //Salvar Novo
                await this.createVisitante(cadastro)
            }
        }
    },
    computed:{
        ...mapGetters(['StateIDSecureVisitantes',
                        'StateIDSecureVisitantesLoading',
                        'StateVisitantesGrupos'
                        ]),
        hasLogVisitantePerm(){
            return this.$router.resolve({name: 'logvisitante'}).meta.has_perm()
        }
    },
}
</script>
<style >
</style>